import Loader from "./Loader";

export {
    Loader
}
